import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

const newItem = () => ({ id: crypto.randomUUID(), question: "", answer: "" });

export default function FaqEditor() {
  const [items, setItems] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/faq").then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  }, []);

  const update = (id, field, value) => setItems((xs) => xs.map((x) => (x.id === id ? { ...x, [field]: value } : x)));
  const move = (i, d) => setItems((xs) => {
    const n = [...xs];
    [n[i], n[i + d]] = [n[i + d], n[i]];
    return n;
  });
  const remove = (id) => window.confirm("¿Borrar esta pregunta?") && setItems((xs) => xs.filter((x) => x.id !== id));

  const save = async () => {
    if (items.some((x) => !x.question.trim() || !x.answer.trim())) {
      toast.error("Cada bloque necesita pregunta y respuesta");
      return;
    }
    setSaving(true);
    try {
      await api.put("/admin/faq", { items });
      toast.success("Preguntas frecuentes guardadas ✦");
    } catch (e) { toast.error(e?.response?.data?.detail || "No se pudo guardar"); }
    finally { setSaving(false); }
  };

  if (!items) return <p className="text-zinc-500 text-sm">Cargando…</p>;

  return (
    <div data-testid="faq-editor" className="space-y-4">
      <p className="text-zinc-400 text-sm">
        Aparecen al final de <strong className="text-white">Solicitar mi lectura</strong>. Si no hay ninguna, la sección no se muestra.
      </p>
      {items.map((it, i) => (
        <div key={it.id} data-testid={`faq-item-${i}`} className="border border-white/10 p-4 space-y-3">
          <div className="flex items-center justify-between gap-2">
            <span className="overline">Pregunta {i + 1}</span>
            <div className="flex gap-2">
              <button data-testid={`faq-up-${i}`} disabled={i === 0} onClick={() => move(i, -1)}
                className="btn-ghost !py-1 !px-2 text-xs disabled:opacity-30">↑</button>
              <button data-testid={`faq-down-${i}`} disabled={i === items.length - 1} onClick={() => move(i, 1)}
                className="btn-ghost !py-1 !px-2 text-xs disabled:opacity-30">↓</button>
              <button data-testid={`faq-delete-${i}`} onClick={() => remove(it.id)}
                className="btn-ghost !py-1 !px-2 text-xs hover:!text-red-400">Borrar</button>
            </div>
          </div>
          <input data-testid={`faq-question-${i}`} className="input-field" placeholder="Pregunta"
            value={it.question} onChange={(e) => update(it.id, "question", e.target.value)} />
          <textarea data-testid={`faq-answer-${i}`} rows={3} className="input-field" placeholder="Respuesta"
            value={it.answer} onChange={(e) => update(it.id, "answer", e.target.value)} />
        </div>
      ))}
      <div className="flex flex-wrap gap-3">
        <button data-testid="faq-add" onClick={() => setItems((xs) => [...xs, newItem()])} className="btn-ghost text-sm">
          + Agregar pregunta
        </button>
        <button data-testid="faq-save" onClick={save} disabled={saving} className="btn-lilac text-sm">
          {saving ? "Guardando…" : "Guardar preguntas ✦"}
        </button>
      </div>
    </div>
  );
}
